import { enumStaticTextType } from "../constants";
import { QStaticText } from "../CoreApp/QStaticText";

export function AddWrapText(
  panel,
  xPos,
  yPos,
  availableWidth,
  label,
  bold,
  textColor,
  fontName,
  fontSize,
  maxRows
) {
  var st = new QStaticText();
  st.InitStaticText();

  if (fontName != null) st.SetFontName(fontName);

  if (fontSize != null) st.SetFontSize(fontSize);

  if (maxRows != null) st.fMaxRows = maxRows;

  st.SetLabel(label);
  st.SetBold(bold);
  st.SetAlignment("left");
  st.PositionElement(xPos, yPos);
  st.SetAvailableWidth(availableWidth);
  st.SetSizingMode(enumStaticTextType.multiline);

  st.AutoSize();

  if (textColor != null) st.SetTextColor(textColor);

  panel.PushElement(st);

  return st;
}
